<template>
    <section :id="`element-${settings.id}`" class="elle-slider padd-v" :style="{ backgroundColor: settings?.color }">
        <div class="container">
            <UiHeadline
                :settings="{
                    label: settings?.label,
                    headline: settings?.headline
                }"
            />
            <UiSlider>
                <template #sliders>
                    <swiper-slide v-for="item in items" :key="item.id" class="swiper-slide">
                        <CardsLocation v-if="settings?.typeHandle == 'locationSlider'" :location="item" />
                        <CardsPerson v-if="settings?.typeHandle == 'teamSlider'" :person="item" />
                    </swiper-slide>
                </template>
            </UiSlider>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});

const items = computed(() => (props.settings?.typeHandle == 'locationSlider' ? props.settings?.locations : props.settings?.team));
</script>
